import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var FormValidationError = function FormValidationError(_ref) {
  var errorMessage = _ref.errorMessage,
      className = _ref.className;
  return /*#__PURE__*/_jsx("p", {
    className: clsx('text-red mt-2 text-xs font-bold italic leading-3', className),
    children: errorMessage
  });
};